import { useState } from "react";
import {
  Flex,
  Input,
  Button,
  InputGroup,
  Stack,
  InputLeftElement,
  chakra,
  Box,
  Avatar,
  FormControl,
  InputRightElement,
  useToast,
  Text,
} from "@chakra-ui/react";
import { FaPhoneAlt, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { config } from "../helpers/config";
import { useCookies } from "react-cookie";
import LoadingPage from "./LoadingPage";
import { useForm } from "../helpers/useForm";
import { baseService } from "../helpers/baseService";

const CFPhoneAlt = chakra(FaPhoneAlt);
const CFaLock = chakra(FaLock);

export default function Login() {
  const [loadingPage, setLoadingPage] = useState(false);
  // eslint-disable-next-line
  const [cookies, setCookie] = useCookies(["auth", "user"]);
  const { values, handleValueChange } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const toast = useToast();

  async function handleLogin(e) {
    e.preventDefault();
    setLoadingPage(true);

    await baseService.post(
      config.services.user.login,
      values,
      (res) => {
        localStorage.setItem("accessToken", res.data.auth.accessToken);
        window.location.href = "/profile";
        setCookie("auth", res.data.auth, { path: "/" });
        setCookie("user", res.data.user, { path: "/" });
        toast({
          title: "Login Berhasil",
          position: "top",
          description: `Welcome ${res.data.user.name}!`,
          status: "success",
          duration: 3000,
          size: "md",
          isClosable: true,
        });
      },
      (err) => {
        toast({
          description: err.data.message,
          size: "10",
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      }
    );
    setLoadingPage(false);
  }

  return (
    <>
      {loadingPage && <LoadingPage />}
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="var(--page-height)"
      >
        <Stack
          flexDir="column"
          mb="2"
          justifyContent="center"
          alignItems="center"
        >
          <Avatar bg="blue.500" />
          <Box>
            <form onSubmit={handleLogin}>
              <Stack
                spacing={4}
                p="1rem"
                backgroundColor="whiteAlpha.900"
                boxShadow="lg"
              >
                <FormControl isRequired>
                  <InputGroup>
                    <InputLeftElement
                      pointerEvents="none"
                      children={<CFPhoneAlt color="gray.300" />}
                    />
                    <Input
                      fontSize={14}
                      placeholder="Nomor handphone"
                      name="phoneNumber"
                      onChange={handleValueChange}
                    />
                  </InputGroup>
                </FormControl>
                <FormControl isRequired>
                  <InputGroup>
                    <InputLeftElement
                      pointerEvents="none"
                      color="gray.300"
                      children={<CFaLock color="gray.300" />}
                    />
                    <Input
                      fontSize={14}
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      name="password"
                      onChange={handleValueChange}
                    />
                    <InputRightElement
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {!values.password ? null : showPassword ? (
                        <FaEyeSlash />
                      ) : (
                        <FaEye />
                      )}
                    </InputRightElement>
                  </InputGroup>
                </FormControl>
                <Button
                  borderRadius={0}
                  type="submit"
                  variant="solid"
                  colorScheme="blue"
                  width="full"
                  fontSize="sm"
                >
                  Masuk
                </Button>
              </Stack>
            </form>
          </Box>
          <Text fontSize="xs" w="100%" textAlign="end" color="gray">
            Belum punya akun?{" "}
            <Link to="/register" style={{ color: "blue" }}>
              Daftar
            </Link>
          </Text>
        </Stack>
      </Flex>
    </>
  );
}
